export const PERSONAL_INFORMATION_SAVE = 'USER_SETTINGS/PERSONAL_INFORMATION_SAVE';
export const PERSONAL_INFORMATION_CLEAR = 'USER_SETTINGS/PERSONAL_INFORMATION_CLEAR';
export const CHANGE_EMAIL_REQUEST = 'USER_SETTINGS/CHANGE_EMAIL_REQUEST';
export const CHANGE_EMAIL_SUCCESS = 'USER_SETTINGS/CHANGE_EMAIL_SUCCESS';
export const CHANGE_EMAIL_FAILURE = 'USER_SETTINGS/CHANGE_EMAIL_FAILURE';
export const CHANGE_EMAIL_CLEAR_ERROR = 'USER_SETTINGS/CHANGE_EMAIL_CLEAR_ERROR';
